import { ReactNode, useEffect, useState } from "react";

type Query = {
  data: Object | undefined;
  error?: Object | undefined;
  loading: boolean;
};

type Props = {
  children: ReactNode;
  loadingContent: ReactNode;
  queries: Query[];
};

const SkeletonLoader = ({ children, loadingContent, queries }: Props) => {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (queries.some(query => query.error)) {
      setLoading(false);
    } else if (queries.some(query => query.loading || queries.some(query => !query.data))) {
      setLoading(true);
    } else {
      setLoading(false);
    }
  }, [queries]);

  return <>{loading ? <div>{loadingContent}</div> : children}</>;
};

export default SkeletonLoader;
